import Vue from 'vue';
import Vuex from 'vuex';
import windowUtils from '@/utils/window-utils';
import vuexLoggerPlugin from '@/utils/vuex-logger-plugin';
import createState from './state';
import mutations from './mutations';
import g2wEnv from './modules/g2w-env';
import system from './modules/system';
import features from './modules/features';

Vue.use(Vuex);

const plugins = [];
const logParams = {};

if (windowUtils.readBooleanQueryParameter('debug')) {
  logParams.includeStates = true;
}

plugins.push(vuexLoggerPlugin.createLogger(logParams));

export const createStoreConfig = () => ({
  mutations,
  state: createState(),
  modules: {
    g2wEnv,
    system,
    features
  },
  plugins
});

const store = (TEST) ? null : new Vuex.Store(createStoreConfig());

export default store;
